import commonAm from './locales/am/common.json';
import commonAz from './locales/az/common.json';
import commonDe from './locales/de/common.json';
import commonEn from './locales/en/common.json';
import commonEs from './locales/es/common.json';
import commonFr from './locales/fr/common.json';
import commonGe from './locales/ge/common.json';
import commonHi from './locales/hi/common.json';
import commonIdn from './locales/idn/common.json';
import commonKg from './locales/kg/common.json';
import commonKr from './locales/kr/common.json';
import commonKz from './locales/kz/common.json';
import commonRu from './locales/ru/common.json';
import commonTh from './locales/th/common.json';
import commonTj from './locales/tj/common.json';
import commonTr from './locales/tr/common.json';
import commonUa from './locales/ua/common.json';
import commonUz from './locales/uz/common.json';

// The most complete dictionary; used as the source of translation key types.
export type DefaultResourse = 'ru';

export enum TranslationNamespace {
  Common = 'common',
}

export const defaultNS = 'common';

export const resources = {
  am: {
    [defaultNS]: commonAm,
  },
  az: {
    [defaultNS]: commonAz,
  },
  de: {
    [defaultNS]: commonDe,
  },
  en: {
    [defaultNS]: commonEn,
  },
  es: {
    [defaultNS]: commonEs,
  },
  fr: {
    [defaultNS]: commonFr,
  },
  ge: {
    [defaultNS]: commonGe,
  },
  hi: {
    [defaultNS]: commonHi,
  },
  idn: {
    [defaultNS]: commonIdn,
  },
  kg: {
    [defaultNS]: commonKg,
  },
  kr: {
    [defaultNS]: commonKr,
  },
  kz: {
    [defaultNS]: commonKz,
  },
  ru: {
    [defaultNS]: commonRu,
  },
  th: {
    [defaultNS]: commonTh,
  },
  tj: {
    [defaultNS]: commonTj,
  },
  tr: {
    [defaultNS]: commonTr,
  },
  ua: {
    [defaultNS]: commonUa,
  },
  uz: {
    [defaultNS]: commonUz,
  },
};
